var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"chat__panel chat-panel"},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"chat-panel__scroller"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }